import { useEffect, useState } from 'react';
import { safeGetItem, safeSetItem } from '../utils/storage';

// IL CONTO ALLA ROVESCIA DELL'OFFERTA LAMPO (2026-09-07, test di qualche giorno).
//
// UN SOLO TIMER PER TUTTO IL SITO, ed e' il punto: il banner compare in tre
// posti (barra della home, card mobile, barra del file manager) e se ognuno
// contasse per conto suo mostrerebbero secondi diversi nello stesso istante.
// Qui la scadenza e' UN VALORE SOLO, in localStorage, e ogni istanza legge
// quello: due schede aperte insieme mostrano lo stesso numero.
//
// PARTE DALLA PRIMA VISITA, non da una data fissa: 24 ore da quando questa
// persona ha visto il sito la prima volta. Sta in localStorage perche' altrimenti
// si azzererebbe a ogni cambio pagina, e un conto che riparte da 24:00:00
// mentre si naviga si smaschera da solo.
//
// QUANDO ARRIVA A ZERO RIPARTE DA 24 ORE. E' una scelta dell'operatore per
// questo test: se un domani l'offerta deve finire davvero, si toglie il
// rinnovo qui sotto e basta — nessun altro file lo sa.
const CHIAVE = 'lc_offerta_lampo_scade';
const VENTIQUATTRO = 24 * 60 * 60 * 1000;

function leggiScadenza() {
  const ora = Date.now();
  const salvata = Number(safeGetItem(CHIAVE));
  // Valida solo se e' un numero nel futuro e non piu' lontano di 24 ore: un
  // valore corrotto o manomesso a mano non deve produrre un conto assurdo.
  if (Number.isFinite(salvata) && salvata > ora && salvata - ora <= VENTIQUATTRO + 60000) {
    return salvata;
  }
  const nuova = ora + VENTIQUATTRO;
  safeSetItem(CHIAVE, String(nuova));
  return nuova;
}

// "23:59:41" — ore:minuti:secondi, sempre due cifre, cosi' la larghezza non
// balla a ogni scatto (le cifre tabulari le mette il CSS).
export function formattaConto(ms) {
  const tot = Math.max(0, Math.floor(ms / 1000));
  const due = (n) => String(n).padStart(2, '0');
  return `${due(Math.floor(tot / 3600))}:${due(Math.floor((tot % 3600) / 60))}:${due(tot % 60)}`;
}

export function useContoOfferta() {
  const [scadenza, setScadenza] = useState(leggiScadenza);
  const [resto, setResto] = useState(() => scadenza - Date.now());

  useEffect(() => {
    const id = setInterval(() => {
      const r = scadenza - Date.now();
      if (r <= 0) {
        // Rinnovo: nuova finestra di 24 ore, scritta una volta sola.
        const nuova = Date.now() + VENTIQUATTRO;
        safeSetItem(CHIAVE, String(nuova));
        setScadenza(nuova);
        setResto(VENTIQUATTRO);
        return;
      }
      setResto(r);
    }, 1000);
    return () => clearInterval(id);
  }, [scadenza]);

  // Il ritorno di una scheda in primo piano non deve mostrare un conto fermo
  // a quando e' stata nascosta: i timer vengono rallentati in background.
  useEffect(() => {
    const risveglia = () => {
      if (document.visibilityState === 'visible') setResto(leggiScadenza() - Date.now());
    };
    document.addEventListener('visibilitychange', risveglia);
    window.addEventListener('focus', risveglia);
    return () => {
      document.removeEventListener('visibilitychange', risveglia);
      window.removeEventListener('focus', risveglia);
    };
  }, []);

  return formattaConto(resto);
}
